import { useState, useEffect, useRef } from "react";
import NewHeader from "../components/Header/NewHeader";
import Footer from "../components/Footer/Footer";
import { Helmet } from "react-helmet-async";

/* ─────────────────────────────────────────
   DATA
───────────────────────────────────────── */
const ORIGIN = { name: "Australia", code: "au", coords: [151.2093, -33.8688] };

const COUNTRIES = [
  { name: "Philippines", code: "ph", coords: [120.9842, 14.5995], fb: "https://www.facebook.com/signetinstituteofaustralia/" },
  { name: "Vietnam",     code: "vn", coords: [105.8342, 21.0278], fb: "https://www.facebook.com/signetinstituteofaustralia/" },
  { name: "Cambodia",    code: "kh", coords: [104.9160, 11.5564], fb: "https://www.facebook.com/signetinstituteofaustralia/" },
  { name: "India",       code: "in", coords: [ 77.2090, 28.6139], fb: "https://www.facebook.com/signet.australia.india" },
  { name: "Indonesia",   code: "id", coords: [106.8456, -6.2088], fb: "https://www.facebook.com/profile.php?id=61579110789190#" },
  { name: "Kenya",       code: "ke", coords: [ 36.8219, -1.2921], fb: "https://www.facebook.com/p/Signet-Institute-of-Australia-Kenya-61578072195236/" },
];

const FLAGS = {
  au: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGlkPSJmbGFnLWljb25zLWF1IiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPHBhdGggZmlsbD0iIzAwMDA4QiIgZD0iTTAgMGg1MTJ2NTEySDB6Ii8+CiAgPHBhdGggZmlsbD0iI2ZmZiIgZD0iTTI1NiAwdjMybC05NSA5NiA5NSA5My41VjI1NmgtMzMuNUwxMjcgMTYybC05MyA5NEgwdi0zNGw5My05My41TDAgMzdWMGgzMWw5NiA5NCA5My05NHoiLz4KICA8cGF0aCBmaWxsPSJyZWQiIGQ9Im05MiAxNjIgNS41IDE3TDIxIDI1Nkgwdi0xLjV6bTYyLTYgMjcgNCA3NSA3My41VjI1NnpNMjU2IDBsLTk2IDk4LTItMjIgNzUtNzZ6TTAgLjUgOTYuNSA5NSA2NyA5MSAwIDI0LjV6Ii8+CiAgPHBhdGggZmlsbD0iI2ZmZiIgZD0iTTg4IDB2MjU2aDgwVjB6TTAgODh2ODBoMjU2Vjg4eiIvPgogIDxwYXRoIGZpbGw9InJlZCIgZD0iTTAgMTA0djQ4aDI1NnYtNDh6TTEwNCAwdjI1Nmg0OFYweiIvPgogIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Im0yMDIgNDAyLjgtNDUuOCA1LjQgNC42IDQ1LjktMzIuOC0zMi40LTMzIDMyLjIgNC45LTQ1LjktNDUuOC01LjhMOTMgMzc3LjQgNjkgMzM4bDQzLjYgMTUgMTUuOC00My40IDE1LjUgNDMuNSA0My43LTE0LjctMjQuMyAzOS4yIDM4LjggMjUuMVptMjIyLjcgOC0yMC41IDIuNiAyLjIgMjAuNS0xNC44LTE0LjQtMTQuNyAxNC41IDItMjAuNS0yMC41LTIuNCAxNy4zLTExLjItMTAuOS0xNy41IDE5LjYgNi41IDYuOS0xOS41IDcuMSAxOS40IDE5LjUtNi43LTEwLjcgMTcuNnpNNDE1IDI5My42bDIuNy0xMy05LjgtOSAxMy4yLTEuNSA1LjUtMTIuMSA1LjUgMTIuMSAxMy4yIDEuNS05LjggOSAyLjcgMTMtMTEuNi02LjZ6bS04NC4xLTYwLTIwLjMgMi4yIDEuOCAyMC4zLTE0LjQtMTQuNS0xNC44IDE0LjEgMi40LTIwLjMtMjAuMi0yLjcgMTcuMy0xMC44LTEwLjUtMTcuNSAxOS4zIDYuOCA3LjItMTkuMSA2LjcgMTkuMyAxOS40LTYuMy0xMC45IDE3LjN6bTE3NS44LTMyLjgtMjAuOSAyLjcgMi4zIDIwLjktMTUuMS0xNC43LTE1IDE0LjggMi4xLTIxLTIwLjktMi40IDE3LjctMTEuNS0xMS4xLTE3LjkgMjAgNi43IDctMTkuOCA3LjIgMTkuOCAxOS45LTYuOS0xMSAxOHptLTgyLjEtODMuNS0yMC43IDIuMyAxLjkgMjAuOC0xNC43LTE0LjhMMzc2IDE0MGwyLjQtMjAuNy0yMC43LTIuOCAxNy43LTExLTEwLjctMTcuOSAxOS43IDYuOSA3LjMtMTkuNSA2LjggMTkuNyAxOS44LTYuNS0xMS4xIDE3LjZ6Ii8+Cjwvc3ZnPgo=",
  ph: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGlkPSJmbGFnLWljb25zLXBoIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPHBhdGggZmlsbD0iIzAwMzhhOCIgZD0iTTAgMGg1MTJ2MjU2SDB6Ii8+CiAgPHBhdGggZmlsbD0iI2NlMTEyNiIgZD0iTTAgMjU2aDUxMnYyNTZIMHoiLz4KICA8cGF0aCBmaWxsPSIjZmZmIiBkPSJNNDQzLjQgMjU2IDAgNTEyVjAiLz4KICA8cGF0aCBmaWxsPSIjZmNkMTE2IiBkPSJtMjUuMiA0NC40IDE1LjQgMTMuMyAxNy45LTkuOC04IDE4LjcgMTUgMTRMNDUgNzguOWwtOC42IDE4LjQtNC43LTE5LjgtMjAuMi0yLjZMMjkgNjQuNHpNMzcyLjEgMjI5bC40IDIwLjMgMTkuMyA2LjctMTkuMyA2LjctLjQgMjAuMy0xMi4zLTE2LjItMTkuNSA2TDM1MiAyNTZsLTExLjctMTYuNyAxOS41IDUuOXpNMzYuNSA0MTQuN2w4LjYgMTguNCAyMC4zLTEuNy0xNC44IDE0IDcuOSAxOC43LTE3LjktOS44LTE1LjQgMTMuMyAzLjktMjAtMTcuNS0xMC41IDIwLjItMi42eiIvPgo8L3N2Zz4K",
  vn: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGlkPSJmbGFnLWljb25zLXZuIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPHBhdGggZmlsbD0iI2RhMjUxZCIgZD0iTTAgMGg1MTJ2NTEySDB6Ii8+CiAgPHBhdGggZmlsbD0iI2ZmMCIgZD0ibTI1NiA3NS4zIDQ4LjIgMTQ4LjNIMTU2LjZsNjUuNiA0Ny43LTI1LjEgNzcuMUwyNTYgMzAxbDU4LjkgNDcuNC0yNS4xLTc3LjEgNjUuNi00Ny43SDE3OC4zeiIvPgo8L3N2Zz4K",
  kh: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGlkPSJmbGFnLWljb25zLWtoIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPHBhdGggZmlsbD0iIzAzMmVhMSIgZD0iTTAgMGg1MTJ2NTEySDB6Ii8+CiAgPHBhdGggZmlsbD0iI2UwMDAyNSIgZD0iTTAgMTI4aDUxMnYyNTZIMHoiLz4KICA8cmVjdCB3aWR0aD0iNTEyIiBoZWlnaHQ9IjI1NiIgeT0iMTI4IiBmaWxsPSIjZTAwMDI1Ii8+Cjwvc3ZnPgo=",
  in: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGlkPSJmbGFnLWljb25zLWluIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPHBhdGggZmlsbD0iI2Y5MyIgZD0iTTAgMGg1MTJ2MTcwLjdIMHoiLz4KICA8cGF0aCBmaWxsPSIjZmZmIiBkPSJNMCAxNzAuN2g1MTJ2MTcwLjZIMHoiLz4KICA8cGF0aCBmaWxsPSIjMTI4ODA3IiBkPSJNMCAzNDEuM2g1MTJWNTEySDB6Ii8+CiAgPGNpcmNsZSBjeD0iMjU2IiBjeT0iMjU2IiByPSI2OCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDA4IiBzdHJva2Utd2lkdGg9IjI0Ii8+Cjwvc3ZnPgo=",
  id: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGlkPSJmbGFnLWljb25zLWlkIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPHBhdGggZmlsbD0iI2U3MDAxMSIgZD0iTTAgMGg1MTJ2MjU2SDB6Ii8+CiAgPHBhdGggZmlsbD0iI2ZmZiIgZD0iTTAgMjU2aDUxMnYyNTZIMHoiLz4KPC9zdmc+Cg==",
  ke: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGlkPSJmbGFnLWljb25zLWtlIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPHBhdGggZmlsbD0iIzAwNjYwMCIgZD0iTTAgMGg1MTJ2NTEySDB6Ii8+CiAgPHBhdGggZmlsbD0iI2ZmZiIgZD0iTTAgMTUwaDUxMnYyMTJIMHoiLz4KICA8cGF0aCBmaWxsPSIjMDAwIiBkPSJNMCAxNzBoNTEydjE3MkgweiIvPgogIDxwYXRoIGZpbGw9IiNiZjAwMDAiIGQ9Ik0yNTYgNjBjLTIyIDAtOTYgMTItMTQwIDE5NiAxLTEgMy0yIDktMiA3IDAgMTcgMiA3NiAzMHM4OCA2MiA1NSAxNjZjMzItMTA0IDU5LTEzOCA1NS0xNjZzNjktMzAgNzYtMzBjNiAwIDggMSA5IDItNDQtMTg0LTExOC0xOTYtMTQwLTE5NnoiLz4KPC9zdmc+Cg==",
};
const FLAG = (c) => FLAGS[c] || "";

/* ─────────────────────────────────────────
   GLOBE
───────────────────────────────────────── */
function GlobeView({ onCountryClick }) {
  const containerRef = useRef(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cleanupFns = [];

    function loadScript(src) {
      return new Promise((res) => {
        if (document.querySelector(`script[src="${src}"]`)) return res();
        const s = document.createElement("script");
        s.src = src;
        s.onload = res;
        document.head.appendChild(s);
      });
    }

    async function init() {
      await loadScript("https://cdn.jsdelivr.net/npm/d3@7/dist/d3.min.js");
      await loadScript("https://cdn.jsdelivr.net/npm/topojson-client@3/dist/topojson-client.min.js");

      const d3 = window.d3;
      const topojson = window.topojson;
      const container = containerRef.current;
      if (!container) return;

      const GOLD = "#D4AF37";
      const reduceMotion = matchMedia("(prefers-reduced-motion: reduce)").matches;
      const ROT_SPEED = 0.0075, DOTS_PER_ARC = 3, ARC_DUR = 4200;
      const HILITE = new Set(["036","608","704","116","356","360","404"].flatMap(v => [v, String(+v)]));
      const arcs = COUNTRIES.map(c => ({ c, interp: d3.geoInterpolate(ORIGIN.coords, c.coords) }));

      let width = 0, height = 0, projection, path, svgEl, layers = {},
          paused = false, dragging = false, lastT = 0, arcPhase = 0;
      let dragStartX = 0, dragStartY = 0, dragStartRotate = [0, 0, 0];
      let isDragging = false;

      function size() {
        const r = container.getBoundingClientRect();
        width = r.width || 500;
        height = r.height || r.width || 500;
      }
      function fitScale() { projection.scale(Math.min(width, height) / 2 - 8); }
      function linePts(interp) {
        const n = 48, a = [];
        for (let i = 0; i <= n; i++) a.push(interp(i / n));
        return a;
      }
      function isVisible(coords) {
        const r = projection.rotate();
        return d3.geoDistance(coords, [-r[0], -r[1]]) < Math.PI / 2 - 0.01;
      }

      function render() {
        if (!projection) return;
        const cx = width / 2, cy = height / 2, R = projection.scale();
        layers.halo.attr("cx", cx).attr("cy", cy).attr("r", R + 1);
        layers.sphere.attr("d", path({ type: "Sphere" }));
        layers.atmos.attr("d", path({ type: "Sphere" }));
        layers.grat.attr("d", path(d3.geoGraticule10()));
        layers.land.selectAll("path").attr("d", path);
        layers.arcs.selectAll("path")
          .attr("d", d => path({ type: "LineString", coordinates: linePts(d.interp) }));
        layers.dots.selectAll("circle").each(function (d) {
          const t = ((arcPhase / ARC_DUR) + d.offset) % 1;
          const p = d.a.interp(t);
          const el = d3.select(this);
          if (isVisible(p)) {
            const xy = projection(p);
            el.attr("cx", xy[0]).attr("cy", xy[1]).attr("opacity", 0.35 + 0.65 * Math.sin(Math.PI * t));
          } else el.attr("opacity", 0);
        });
        const pulse = 1 + (reduceMotion ? 0 : 0.5 + 0.5 * Math.sin(arcPhase / 520));
        layers.marks.selectAll("g.mk").each(function (d) {
          const g = d3.select(this);
          if (isVisible(d.coords)) {
            const xy = projection(d.coords);
            g.attr("transform", `translate(${xy[0]},${xy[1]})`).style("display", null).style("opacity", 1);
            g.select(".mk-pulse").attr("r", (d.origin ? 21 : 16) + pulse * 6).attr("opacity", 0.5 - pulse * 0.18);
          } else g.style("display", "none");
        });
      }

      function rotateTo(coords, cb) {
        paused = true;
        const r0 = projection.rotate(), r1 = [-coords[0], -coords[1], r0[2]];
        const iv = d3.interpolate(r0, r1);
        d3.transition().duration(750).ease(d3.easeCubicInOut)
          .tween("r", () => tt => { projection.rotate(iv(tt)); render(); })
          .on("end", () => { if (cb) cb(); if (!reduceMotion) setTimeout(() => { paused = false; }, 2600); });
      }
      window.__globeRotateTo = rotateTo;

      const world = await d3.json("https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json");
      size();

      const land = topojson.feature(world, world.objects.countries);
      projection = d3.geoOrthographic().clipAngle(90).rotate([-104, 8, 0]).translate([width / 2, height / 2]);
      fitScale();
      path = d3.geoPath(projection);

      // Create SVG directly on container via D3
      svgEl = d3.select(container)
        .append("svg")
        .attr("viewBox", `0 0 ${width} ${height}`)
        .attr("width", "100%")
        .attr("height", "100%")
        .style("display", "block")
        .style("overflow", "visible")
        // Cursor styling via style, not CSS class, so D3 drag can override cleanly
        .style("cursor", "grab");

      // ── defs
      const defs = svgEl.append("defs");
      const ocean = defs.append("radialGradient").attr("id", "gn-ocean").attr("cx", "42%").attr("cy", "38%");
      ocean.append("stop").attr("offset", "0%").attr("stop-color", "#1a160c");
      ocean.append("stop").attr("offset", "62%").attr("stop-color", "#0d0b07");
      ocean.append("stop").attr("offset", "100%").attr("stop-color", "#070608");
      const landG = defs.append("linearGradient").attr("id", "gn-land").attr("x1","0").attr("y1","0").attr("x2","0").attr("y2","1");
      landG.append("stop").attr("offset","0%").attr("stop-color","#b89230");
      landG.append("stop").attr("offset","100%").attr("stop-color","#7d6320");
      const hi = defs.append("linearGradient").attr("id","gn-landhi").attr("x1","0").attr("y1","0").attr("x2","0").attr("y2","1");
      hi.append("stop").attr("offset","0%").attr("stop-color","#ffe9a8");
      hi.append("stop").attr("offset","100%").attr("stop-color","#e6bb45");
      const glow = defs.append("filter").attr("id","gn-glow").attr("x","-60%").attr("y","-60%").attr("width","220%").attr("height","220%");
      glow.append("feGaussianBlur").attr("stdDeviation","2.4").attr("result","b");
      const fm = glow.append("feMerge");
      fm.append("feMergeNode").attr("in","b");
      fm.append("feMergeNode").attr("in","SourceGraphic");
      COUNTRIES.concat([ORIGIN]).forEach(c => {
        defs.append("clipPath").attr("id","gn-clip-"+c.code).append("circle").attr("r", c === ORIGIN ? 20 : 15);
      });

      // ── layers
      layers.halo   = svgEl.append("circle").attr("fill","none").attr("stroke","rgba(212,175,55,.20)").attr("stroke-width",1.2);
      layers.sphere = svgEl.append("path").attr("fill","url(#gn-ocean)");
      layers.atmos  = svgEl.append("path").attr("fill","none").attr("stroke","rgba(212,175,55,.10)").attr("stroke-width",16).style("filter","blur(10px)");
      layers.grat   = svgEl.append("path").attr("fill","none").attr("stroke","rgba(212,175,55,.10)").attr("stroke-width",.5);
      layers.land   = svgEl.append("g");
      layers.arcs   = svgEl.append("g");
      layers.dots   = svgEl.append("g");
      layers.marks  = svgEl.append("g");

      // Invisible hit rect so drag works on the ocean (empty SVG areas have no pointer events)
      svgEl.insert("rect", ":first-child")
        .attr("width", width).attr("height", height)
        .attr("fill", "transparent");

      layers.land.selectAll("path").data(land.features).join("path")
        .attr("fill", d => HILITE.has(String(d.id)) ? "url(#gn-landhi)" : "url(#gn-land)")
        .attr("stroke", d => HILITE.has(String(d.id)) ? "rgba(255,233,168,.6)" : "rgba(10,9,5,.55)")
        .attr("stroke-width", d => HILITE.has(String(d.id)) ? .8 : .4);

      layers.arcs.selectAll("path").data(arcs).join("path")
        .attr("fill","none").attr("stroke","rgba(212,175,55,.30)").attr("stroke-width",1).attr("stroke-linecap","round");

      const dotData = [];
      arcs.forEach(a => { for (let k = 0; k < DOTS_PER_ARC; k++) dotData.push({ a, offset: k / DOTS_PER_ARC }); });
      layers.dots.selectAll("circle").data(dotData).join("circle").attr("r",2.4).attr("fill","#fff3cf").style("filter","url(#gn-glow)");

      // Always look up the full country from COUNTRIES array by code — guarantees fb URL is always present
      const getCountry = (d) => COUNTRIES.find(c => c.code === d.code) || d;

      const allPts = [Object.assign({ origin: true }, ORIGIN)].concat(COUNTRIES);
      const mk = layers.marks.selectAll("g.mk").data(allPts).join("g")
        .attr("class","mk").attr("tabindex",0).attr("role","button")
        .style("pointer-events", "all")
        .on("click", (e, d) => {
          if (isDragging) return; // ignore click at end of drag
          if (!d.origin) { const c = getCountry(d); rotateTo(c.coords, () => onCountryClick(c)); }
        })
        .on("keydown", (e, d) => {
          if ((e.key === "Enter" || e.key === " ") && !d.origin) {
            e.preventDefault();
            const c = getCountry(d);
            rotateTo(c.coords, () => onCountryClick(c));
          }
        });
      mk.filter(d => d.origin).style("cursor","default");
      mk.append("circle").attr("class","mk-pulse").attr("fill","none").attr("stroke","rgba(242,214,128,.5)").attr("stroke-width",1.2);
      mk.append("circle").attr("class","mk-ring")
        .attr("r", d => d.origin ? 21 : 16).attr("fill","none")
        .attr("stroke", d => d.origin ? "#ffffff" : GOLD)
        .attr("stroke-width", d => d.origin ? 2.6 : 2).style("filter","url(#gn-glow)");
      mk.append("image")
        .attr("href", d => FLAG(d.code)).attr("xlink:href", d => FLAG(d.code))
        .attr("width", d => d.origin ? 40 : 30).attr("height", d => d.origin ? 40 : 30)
        .attr("x", d => d.origin ? -20 : -15).attr("y", d => d.origin ? -20 : -15)
        .attr("preserveAspectRatio","xMidYMid slice").attr("clip-path", d => `url(#gn-clip-${d.code})`);
      mk.append("text").attr("class","mk-label").attr("text-anchor","middle")
        .attr("y", d => d.origin ? -29 : -24)
        .attr("fill","#ECE6D6").style("font-size","11px")
        .text(d => d.origin ? "AUSTRALIA · HQ" : d.name.toUpperCase());

      setLoaded(true);

      // ── Drag: attach to SVG element, use pointer events for cross-device support
      let prevX = 0, prevY = 0;

      function onPointerDown(e) {
        if (e.button !== undefined && e.button !== 0) return; // left button only
        isDragging = false;
        dragging = true;
        prevX = e.clientX ?? e.touches?.[0]?.clientX ?? 0;
        prevY = e.clientY ?? e.touches?.[0]?.clientY ?? 0;
        svgEl.style("cursor", "grabbing");
        e.preventDefault();
      }

      function onPointerMove(e) {
        if (!dragging) return;
        const clientX = e.clientX ?? e.touches?.[0]?.clientX ?? prevX;
        const clientY = e.clientY ?? e.touches?.[0]?.clientY ?? prevY;
        const dx = clientX - prevX;
        const dy = clientY - prevY;
        if (Math.abs(dx) > 2 || Math.abs(dy) > 2) isDragging = true;
        prevX = clientX;
        prevY = clientY;
        const r = projection.rotate();
        projection.rotate([
          r[0] + dx * 0.35,
          Math.max(-85, Math.min(85, r[1] - dy * 0.35)),
          r[2]
        ]);
        render();
        e.preventDefault();
      }

      function onPointerUp(e) {
        if (!dragging) return;
        dragging = false;
        svgEl.style("cursor", "grab");
        // Reset isDragging after a short delay so click events don't fire during drag-end
        setTimeout(() => { isDragging = false; }, 50);
      }

      const svgNode = svgEl.node();
      svgNode.addEventListener("mousedown",  onPointerDown, { passive: false });
      svgNode.addEventListener("touchstart", onPointerDown, { passive: false });
      window.addEventListener("mousemove",   onPointerMove, { passive: false });
      window.addEventListener("touchmove",   onPointerMove, { passive: false });
      window.addEventListener("mouseup",     onPointerUp);
      window.addEventListener("touchend",    onPointerUp);

      cleanupFns.push(() => {
        svgNode.removeEventListener("mousedown",  onPointerDown);
        svgNode.removeEventListener("touchstart", onPointerDown);
        window.removeEventListener("mousemove",   onPointerMove);
        window.removeEventListener("touchmove",   onPointerMove);
        window.removeEventListener("mouseup",     onPointerUp);
        window.removeEventListener("touchend",    onPointerUp);
      });

      // ── Resize
      function handleResize() {
        size();
        projection.translate([width / 2, height / 2]);
        fitScale();
        svgEl.attr("viewBox", `0 0 ${width} ${height}`);
        // Update hit rect too
        svgEl.select("rect").attr("width", width).attr("height", height);
        render();
      }
      window.addEventListener("resize", handleResize);
      cleanupFns.push(() => window.removeEventListener("resize", handleResize));

      // ── Animation loop
      if (reduceMotion) paused = true;
      d3.timer(t => {
        const dt = t - lastT; lastT = t;
        if (!paused && !dragging) {
          const r = projection.rotate();
          r[0] += ROT_SPEED * dt;
          projection.rotate(r);
        }
        if (!reduceMotion) arcPhase += dt;
        render();
      });
      render();
    }

    init().catch(console.error);
    return () => cleanupFns.forEach(fn => fn());
  }, [onCountryClick]);

  return (
    <div className="gn-globe-stage">
      {/* container for SVG — D3 appends the SVG directly here */}
      <div ref={containerRef} className="gn-globe-canvas" />
      {!loaded && (
        <div className="gn-globe-loading">
          <div className="gn-globe-ring" />
          <span>Rendering network…</span>
        </div>
      )}
      <p className="gn-globe-hint">
        <svg width={13} height={13} viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="1.8">
          <path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M18.4 5.6l-2.1 2.1M7.7 16.3l-2.1 2.1"/>
        </svg>
        Drag to spin · tap a flag
      </p>
    </div>
  );
}

/* ─────────────────────────────────────────
   POPUP
───────────────────────────────────────── */
function CountryPopup({ country, onClose }) {
  useEffect(() => {
    const fn = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", fn);
    return () => document.removeEventListener("keydown", fn);
  }, [onClose]);

  if (!country) return null;
  return (
    <div className="gn-pop-back" onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="gn-pop">
        <button className="gn-pop-close" onClick={onClose} aria-label="Close">×</button>
        <img className="gn-pop-flag" src={FLAG(country.code)} alt={`${country.name} flag`} />
        <h3 className="gn-pop-country">{country.name}</h3>
        <p className="gn-pop-sub">Signet Network</p>
        <a className="gn-pop-fb" href={country.fb} target="_blank" rel="noopener noreferrer">
          <svg width={20} height={20} viewBox="0 0 24 24" fill="currentColor">
            <path d="M24 12.07C24 5.4 18.63 0 12 0S0 5.4 0 12.07C0 18.1 4.39 23.1 10.13 24v-8.44H7.08v-3.49h3.05V9.41c0-3.02 1.79-4.69 4.53-4.69 1.31 0 2.68.24 2.68.24v2.97h-1.51c-1.49 0-1.95.93-1.95 1.89v2.25h3.32l-.53 3.49h-2.79V24C19.61 23.1 24 18.1 24 12.07z"/>
          </svg>
          Visit our Facebook
        </a>
        <p className="gn-pop-note">Stories, events &amp; student life from this region.</p>
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────
   PAGE
───────────────────────────────────────── */
const GlobalNetwork = () => {
  const [popup, setPopup] = useState(null);
  const [hoveredCard, setHoveredCard] = useState(null);

  return (
    <>
      <Helmet>
        <title>Global Network – Signet Institute of Australia</title>
        <meta name="description" content="Signet Institute connects Australian vocational training with partners and learners across seven countries." data-rh="true" />
      </Helmet>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Archivo:wght@700;800;900&family=JetBrains+Mono:wght@400;500&display=swap');

        /* ── Globe stage ── */
        .gn-hero-globe {
          border-radius: 24px;
          overflow: hidden;
          position: relative;
        }
        .gn-globe-stage {
          position: relative;
          width: 100%;
          aspect-ratio: 1 / 1;
          max-height: 620px;
          display: flex;
          align-items: center;
          justify-content: center;
          user-select: none;
          -webkit-user-select: none;
        }
        /* The div that D3 appends the SVG into */
        .gn-globe-canvas {
          width: 100%;
          height: 100%;
          display: block;
        }
        .gn-globe-canvas svg {
          display: block;
          width: 100%;
          height: 100%;
          overflow: visible;
          /* NO touch-action: none here — we handle it in JS */
        }
        .gn-globe-loading {
          position: absolute; inset: 0; display: flex; flex-direction: column;
          align-items: center; justify-content: center; gap: 14px;
          color: rgba(236,230,214,0.56);
          font-size: 11px; letter-spacing: .22em; text-transform: uppercase;
          pointer-events: none;
        }
        .gn-globe-ring {
          width: 36px; height: 36px;
          border: 2px solid rgba(212,175,55,0.16);
          border-top-color: #D4AF37;
          border-radius: 50%;
          animation: gn-spin 1s linear infinite;
        }
        @keyframes gn-spin { to { transform: rotate(360deg); } }
        .gn-globe-hint {
          position: absolute; bottom: 35px; left: 50%; transform: translateX(-50%);
          display: flex; align-items: center; gap: 7px;
          font-size: 10px; letter-spacing: .2em; text-transform: uppercase;
          color: rgba(212,175,55,0.5); white-space: nowrap; margin: 0;
          pointer-events: none;
        }
        .mk .mk-label { opacity: 0; transition: opacity .18s; }
        .mk:hover .mk-label, .mk.is-active .mk-label { opacity: 1; }
        .mk-ring { transition: transform .18s; }
        .mk:hover .mk-ring { transform: scale(1.12); }

        /* ── Light hero banner ── */
        .gn-banner {
          background: linear-gradient(135deg, #f8f9ff 0%, #eef1fb 100%);
          border-bottom: 1px solid #e2e6f3;
          padding: 64px 0 52px;
        }
        .gn-hero-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 52px;
          align-items: center;
          margin-top: 5%;
        }
        @media (max-width: 900px) {
          .gn-hero-grid { grid-template-columns: 1fr; gap: 32px; }
          .gn-hero-globe { max-width: 480px; margin: 0 auto; }
        }

        .gn-eyebrow {
          display: inline-flex; align-items: center; gap: 10px;
          font-size: 11px; letter-spacing: .3em; text-transform: uppercase;
          color: #D4AF37; font-weight: 500; margin-bottom: 18px;
        }
        .gn-eyebrow::before {
          content: ""; width: 28px; height: 1px; background: #D4AF37; opacity: .8;
        }
        .gn-h1 {
          font-weight: 900;
          font-size: clamp(36px, 5.5vw, 68px);
          line-height: .96;
          letter-spacing: -.02em;
          color: #0f1323;
          margin: 0 0 20px;
        }
        .gn-h1 .gn-gold {
          background: #D9B576;
          -webkit-background-clip: text; background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .gn-lede {
          font-size: clamp(15px, 1.6vw, 17px);
          color: #4a5068;
          max-width: 44ch;
          line-height: 1.7;
          margin: 0 0 28px;
        }
        .gn-pillars { display: flex; flex-wrap: wrap; gap: 10px; margin-bottom: 32px; }
        .gn-pillar {
          display: inline-flex; align-items: center; gap: 8px;
          background: #fff; border: 1px solid #dde2f0; border-radius: 999px;
          padding: 8px 14px 8px 10px; font-size: 13px; color: #2d3152; font-weight: 500;
          box-shadow: 0 1px 4px rgba(0,0,0,.05);
        }
        .gn-statline {
          display: flex; gap: 32px; flex-wrap: wrap;
          padding-top: 24px; border-top: 1px solid #dde2f0;
        }
        .gn-stat-n {
          font-weight: 900; font-size: 32px; line-height: 1;
          background: #d9b576;
          -webkit-background-clip: text; background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .gn-stat-l {
          font-size: 10px; letter-spacing: .18em; text-transform: uppercase;
          color: #8891b0; margin-top: 6px;
        }

        /* ── Directory ── */
        .gn-directory { padding: 60px 0 80px; background: #fff; }
        .gn-dir-heading {
          font-weight: 800; font-size: 12px;
          letter-spacing: .28em; text-transform: uppercase;
          color: #8891b0; margin-bottom: 20px;
          display: flex; align-items: center; gap: 14px;
        }
        .gn-dir-heading::after { content: ""; flex: 1; height: 1px; background: #e2e6f3; }
        .gn-country-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
          gap: 14px;
        }
        .gn-country-card {
          display: flex; align-items: center; gap: 13px;
          background: #f8f9ff; border: 1px solid #e2e6f3; border-radius: 14px;
          padding: 14px 16px; cursor: pointer; color: #0f1323;
          transition: border-color .2s, background .2s, transform .2s, box-shadow .2s;
          text-align: left; width: 100%; font: inherit;
        }
        .gn-country-card:hover {
          border-color: #D4AF37; background: #fffdf5;
          transform: translateY(-2px); box-shadow: 0 6px 20px rgba(212,175,55,.14);
        }
        .gn-country-card:focus-visible { outline: 2px solid #D4AF37; outline-offset: 2px; }
        .gn-card-flag {
          width: 36px; height: 36px; border-radius: 50%; object-fit: cover;
          border: 1.5px solid #D4AF37; flex-shrink: 0;
          box-shadow: 0 0 0 3px rgba(212,175,55,.12);
        }
        .gn-card-name { font-weight: 700; font-size: 14.5px; color: #0f1323; }
        .gn-card-meta {
          font-size: 9.5px;
          letter-spacing: .12em; color: #8891b0; text-transform: uppercase; margin-top: 2px;
        }
        .gn-card-fb { margin-left: auto; color: #c5cbe0; transition: color .2s; }
        .gn-country-card:hover .gn-card-fb { color: #D4AF37; }

        /* ── Popup ── */
        .gn-pop-back {
          position: fixed; inset: 0; z-index: 500;
          background: rgba(10,12,24,.72); backdrop-filter: blur(8px);
          display: flex; align-items: center; justify-content: center; padding: 24px;
        }
        .gn-pop {
          position: relative; width: 100%; max-width: 380px;
          background: radial-gradient(120% 80% at 50% 0%, rgba(212,175,55,.12), transparent 60%), #131217;
          border: 1px solid rgba(212,175,55,.30);
          border-radius: 22px; padding: 40px 30px 34px; text-align: center;
          animation: gn-pop-in .28s cubic-bezier(.2,.8,.2,1) both;
        }
        @keyframes gn-pop-in { from { transform: translateY(14px) scale(.97); opacity: 0; } to { transform: none; opacity: 1; } }
        .gn-pop-close {
          position: absolute; top: 14px; right: 14px;
          width: 34px; height: 34px; border-radius: 50%;
          background: transparent; border: 1px solid rgba(212,175,55,.2);
          color: rgba(236,230,214,.56); cursor: pointer; font-size: 18px;
          display: flex; align-items: center; justify-content: center; transition: .2s;
        }
        .gn-pop-close:hover { color: #ECE6D6; border-color: rgba(212,175,55,.5); }
        .gn-pop-flag {
          width: 90px; height: 90px; border-radius: 50%; object-fit: cover;
          margin: 0 auto 18px; display: block; border: 2px solid #D4AF37;
          box-shadow: 0 0 0 6px rgba(212,175,55,.10), 0 18px 40px rgba(0,0,0,.5);
        }
        .gn-pop-country {
          font-weight: 900;
          font-size: 28px; letter-spacing: -.01em; color: #ECE6D6; margin: 0;
        }
        .gn-pop-sub {
          font-size: 10.5px;
          letter-spacing: .2em; text-transform: uppercase;
          color: #D4AF37; margin: 8px 0 24px;
        }
        .gn-pop-fb {
          display: inline-flex; align-items: center; gap: 10px;
          text-decoration: none; background: #1877F2; color: #fff;
          font-weight: 600; font-size: 14.5px; padding: 13px 22px; border-radius: 12px;
          transition: transform .18s, filter .18s;
          box-shadow: 0 10px 26px rgba(24,119,242,.32);
        }
        .gn-pop-fb:hover { transform: translateY(-2px); filter: brightness(1.08); }
        .gn-pop-note { margin-top: 16px; font-size: 11.5px; color: rgba(236,230,214,.34); }

        @media (prefers-reduced-motion: reduce) {
          * { animation-duration: .001ms !important; transition-duration: .001ms !important; }
        }
      `}</style>

      <NewHeader />

      {/* ── HERO BANNER ── */}
      <section className="gn-banner">
        <div className="container">
          <div className="gn-hero-grid">
            <div>
              <span className="gn-eyebrow">International Presence</span>
              <h1 className="gn-h1">
                From Australia<br />
                to the <span className="gn-gold">world.</span>
              </h1>
              <p className="gn-lede">
                Signet Institute carries Australian vocational training across borders —
                connecting skilled communities and partners in seven countries. Spin the globe,
                follow the network as it radiates out of Australia, and tap any flag to meet a region.
              </p>
              <div className="gn-pillars">
                {[
                  { label: "Trades & Automotive",     icon: <path d="M3 21h18M5 21V10l7-5 7 5v11M9 21v-5h6v5"/> },
                  { label: "Health & Community Care", icon: <path d="M12 21s-7-4.5-9-9a4.5 4.5 0 0 1 8-3 4.5 4.5 0 0 1 8 3c-2 4.5-7 9-7 9z"/> },
                  { label: "Business & Leadership",   icon: <path d="M3 7h18v13H3zM3 7l3-4h12l3 4M9 12h6"/> },
                ].map(({ label, icon }) => (
                  <span key={label} className="gn-pillar">
                    <svg width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="1.8">{icon}</svg>
                    {label}
                  </span>
                ))}
              </div>
              <div className="gn-statline">
                {[["7","Countries"], ["3","AU Campuses"], ["60+","Nationalities"]].map(([n, l]) => (
                  <div key={l}>
                    <div className="gn-stat-n">{n}</div>
                    <div className="gn-stat-l">{l}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className="gn-hero-globe">
              <GlobeView onCountryClick={setPopup} />
            </div>
          </div>
        </div>
      </section>

      {/* ── DIRECTORY ── */}
      <section className="gn-directory">
        <div className="container">
          <h2 className="gn-dir-heading">The Network</h2>
          <div className="gn-country-grid">
            {COUNTRIES.map(c => (
              <button
                key={c.code}
                className="gn-country-card"
                onMouseEnter={() => setHoveredCard(c.code)}
                onMouseLeave={() => setHoveredCard(null)}
                onClick={() => {
                  if (window.__globeRotateTo) window.__globeRotateTo(c.coords, () => setPopup(c));
                  else setPopup(c);
                }}
              >
                <img src={FLAG(c.code)} alt={`${c.name} flag`} className="gn-card-flag" />
                <span>
                  <span className="gn-card-name">{c.name}</span>
                  <span className="gn-card-meta" style={{ display: "block" }}>Partner Region</span>
                </span>
                <span className="gn-card-fb">
                  <svg width={17} height={17} viewBox="0 0 24 24" fill="currentColor">
                    <path d="M24 12.07C24 5.4 18.63 0 12 0S0 5.4 0 12.07C0 18.1 4.39 23.1 10.13 24v-8.44H7.08v-3.49h3.05V9.41c0-3.02 1.79-4.69 4.53-4.69 1.31 0 2.68.24 2.68.24v2.97h-1.51c-1.49 0-1.95.93-1.95 1.89v2.25h3.32l-.53 3.49h-2.79V24C19.61 23.1 24 18.1 24 12.07z"/>
                  </svg>
                </span>
              </button>
            ))}
          </div>
        </div>
      </section>

      <Footer />

      {popup && <CountryPopup country={popup} onClose={() => setPopup(null)} />}
    </>
  );
};

export default GlobalNetwork;